import { createContext } from 'react';
export const EVMExternalContext = createContext(false);
//# sourceMappingURL=EVMExternalContext.js.map